import Image from "next/image";
import React from "react";
import { ReactNode } from "react";

type Layout = "left" | "top"; // Layout options

interface ContentBlockProps {
  icon?: ReactNode; // Ant Design or other React icons
  imageUrl?: string; // URL of the image
  textPrimary: string; // Main text
  textSecondary?: string; // Optional secondary text
  thirdText?: string; // Optional third text
  layout?: Layout; // Position: "left" or "top"
  link?: string; // Optional link URL
  linkText?: string; // Optional link text
}

const ContentBlock: React.FC<ContentBlockProps> = ({
  icon,
  imageUrl,
  textPrimary,
  textSecondary,
  thirdText,
  layout = "top", // Default layout is top
  link,
  linkText,
}) => {
  const isVertical = layout === "top"; // Check if layout is vertical
  console.log("Image URL:", imageUrl); // Log the image URL
  return (
    <div
      className={`flex h-full min-h-[43.rem] ${
        isVertical ? "flex-col items-center text-center" : "flex-row items-center"
      }`}
    >
      {/* Icon or Image */}
      {icon && <div className="text-3xl">{icon}</div>}
      {imageUrl && 
      <img src={`${imageUrl}`} alt="governer Image" 
      height={500}
          width={300}
      className= "w-full min-h-[17rem] h-fit rounded-t-lg" />}

      {/* Text Content */}
      <div className="bg-[#002B4E] flex flex-col items-start h-full w-full min-w-0 p-4 rounded-b-lg shadow-md">
        <h2 className="text-white font-semibold lg:text-[1.75rem] text-start">{textPrimary}</h2>
        <h3 className="text-white font-normal text-base mb-5">{textSecondary}</h3>
        {textSecondary && (
          <p className="text-[#F7FAFF] flex flex-1 mt-5 text-base tracking-normal font-normal text-start">{thirdText}</p>
        )}

        {/* Conditional Link at Bottom */}
        {link && linkText && (
          <a
            href={link}
            className="mt-4 text-white hover:underline text-sm"
          >
            {linkText}
          </a>
        )}
      </div>
    </div>
  );
};

export default ContentBlock;
